import React, { useEffect, useState } from "react";
import Wizard from "./Wizard";
import BaseInput from "../../BaseInput";
import { Form } from "antd";
import BaseSelect from "../../BaseSelect";
import { LoadingOutlined } from "@ant-design/icons";
import export_icon from "../../../assets/export.svg";
import deleteIcon from "../../../assets/black-x.svg";
import QalortButton from "../../Button";
import { UploadFile } from "../../../services/Utils";
import { useSelector } from "react-redux";
import { Modal, notification } from "antd";
import SvgClose from "../../../icons/SvgClose";
import { getImageBaseUrl } from "../../../services/s3-utils";
import { useCategories } from "../../../hooks/useCategories";
import { getCategoryImage } from "../../../services/image-utils/getCategoryImage";
import { Editor } from "qalort-editor/dist/components/editor/Edit";
import SearchOnline from "./SearchOnline";

export const DeleteButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-[#ECEBF5] h-[58px] w-[58px] flex items-center justify-center absolute right-0 top-0"
    >
      <img src={deleteIcon} alt="" />
    </button>
  );
};
function CohortDetails({
  handleProceed,
  isOpen,
  isDone,
  updateContext,
  formFields,
  hopToLevel,
}) {
  const [topics, setTopics] = useState(formFields?.topics || [""]);
  const [audiences, setAudiences] = useState(formFields?.audiences || [""]);
  const [requirements, setRequirements] = useState(
    formFields?.requirements || [""]
  );
  const [step1Form] = Form.useForm();
  const [uploading, setUploading] = useState(false);
  const qalortUser = useSelector((state) => state.user.userData);
  const categories = useCategories();
  const [addTagsModal, setAddTagsModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const addTopic = () => setTopics([...topics, ``]);
  const addAudience = () => setAudiences([...audiences, ""]);
  const addRequirements = () => setRequirements([...requirements, ""]);

  function checkIsActive(v) {
    return selectedCategory?.category === v.category;
  }

  function deleteOrAddCategory(value) {
    if (checkIsActive(value)) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(value);
      updateContext({ ...formFields, category_id: value?._id });
      setAddTagsModal(false);
    }
  }

  const handleUpload = async (payload) => {
    if (uploading) {
      return;
    }
    setUploading(true);
    try {
      let response = await UploadFile(payload, {
        service: "users",
        access: "public-read",
        path: `/users/${qalortUser?.id}/${Math.random()
          .toString(36)
          .slice(2, 7)}/`,
      });

      updateContext({ ...formFields, banner: response.data.data[0] });
    } catch (err) {
      notification.error({
        message:
          err.response?.data?.message || "An error occured. Please try again",
      });
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    step1Form.setFieldsValue({
      ...formFields,
    });
  }, []);

  useEffect(() => {
    if (formFields?.category_id) {
      let category = categories.find(
        (category) => category._id === formFields?.category_id
      );
      setSelectedCategory(category);
    }
  }, [categories, formFields]);

  const removeTopic = (index) => {
    const newTopics = [...topics];
    newTopics.splice(index, 1);
    setTopics(newTopics);
    updateContext({
      ...formFields,
      topics: newTopics,
    });
  };

  const removeAudience = (index) => {
    const newAudiences = [...audiences];
    newAudiences.splice(index, 1);
    setAudiences(newAudiences);
    updateContext({
      ...formFields,
      audiences: newAudiences,
    });
  };

  const removeRequirement = (index) => {
    const newRequirements = [...requirements];
    newRequirements.splice(index, 1);
    setRequirements(newRequirements);
    updateContext({
      ...formFields,
      requirements: newRequirements,
    });
  };

  return (
    <Form
      form={step1Form}
      defaultValue={formFields}
      onSubmitCapture={(values) => {
        if (!formFields.banner) {
          notification.error({
            message: "Please upload a banner for the cohort",
          });
          return;
        }
        handleProceed();

        updateContext({
          ...formFields,
          ...values,
        });
      }}
    >
      <Wizard
        {...{ isOpen }}
        {...{ isDone }}
        step="1"
        details="Cohort Details"
        onClickHeader={() => {
          !step1Form.getFieldsError().length && hopToLevel(1);
        }}
      >
        <div className="px-5 md:px-[62px] flex flex-col gap-4">
          <BaseInput
            label={
              <span>
                Title <span className="red">*</span>
              </span>
            }
            placeholder="Enter the Cohort title"
            defaultValue={formFields.title}
            name="title"
            rules={[
              { required: true, message: "Please input a title!" },
              { max: 60, message: "Title cannot exceed 60 characters" },
            ]}
            onChange={(e) => {
              if (e.target.value.length > 60) {
                return;
              }
              updateContext({ ...formFields, title: e.target.value });
            }}
            value={formFields.title}
          />
          <p className="text-right -mt-3 text-tint">
            {60 - (formFields?.title?.length || 0)} characters left
          </p>
          <BaseInput
            label={
              <span>
                Description <span className="red">*</span>
              </span>
            }
            placeholder="Briefly describe what your Cohort is about"
            textarea
            name="description"
            defaultValue={formFields.description}
            rules={[
              { required: true, message: "Please input a description!" },
              { max: 150, message: "description cannot exceed 160 characters" },
            ]}
            onChange={(e) => {
              if (e.target.value.length > 150) {
                return;
              }
              updateContext({ ...formFields, description: e.target.value });
            }}
            value={formFields.description}
          />
          <p className="text-right -mt-3 text-tint">
            {150 - (formFields?.description?.length || 0)} characters left
          </p>
          <span className="p-xs font-medium text-main -mb-3">
            Long description <span className="red">*</span>
          </span>
          <div className="w-full cohort-editor">
            <Editor
              isQalortInput
              hideSave={true}
              canRecord={false}
              value={formFields.long_description}
              onChange={(e) => {
                updateContext({
                  ...formFields,
                  long_description: e,
                });
              }}
              onCreateMessageData={() => {}}
              onSendMessage={() => {}}
            />
            <p className="text-right mt-1 text-tint">
              {3000 - (formFields?.long_description?.length || 0)} characters
              left
            </p>
          </div>
          <div>
            <div className="flex flex-col gap-3">
              {topics.map((topicName, index) => (
                <BaseInput
                  key={index}
                  value={topicName}
                  label={
                    index === 0 ? <span>Topics you will explore</span> : ""
                  }
                  placeholder="Outline the key topics you’ll explore"
                  name={`topics[${index}]`}
                  rules={[{ required: true, message: "Please input a topic!" }]}
                  onChange={(e) => {
                    const updateTopics = [...topics];
                    updateTopics[index] = e.target.value;
                    setTopics(updateTopics);
                    updateContext({
                      ...formFields,
                      topics: updateTopics,
                    });
                  }}
                  className="relative overflow-hidden"
                  suffixClassName="top-0 bottom-0 !right-0"
                  onEnter={() => addTopic()}
                >
                  {index > 0 && (
                    <DeleteButton onClick={() => removeTopic(index)} />
                  )}
                </BaseInput>
              ))}
            </div>
            <p
              className="p-xs font-medium text-disabled mt-2 mb-0 cursor-pointer"
              onClick={addTopic}
            >
              + Add another topic
            </p>
          </div>
          <div>
            <div className="flex flex-col gap-3">
              {audiences.map((audience, index) => (
                <BaseInput
                  key={index}
                  value={audience}
                  label={index === 0 ? "This class is for" : ""}
                  name={`audiences[${index}]`}
                  placeholder="E.g., Designers"
                  rules={[
                    { required: true, message: "Please input an audience!" },
                  ]}
                  onChange={(e) => {
                    const updateAudiences = [...audiences];
                    updateAudiences[index] = e.target.value;
                    setAudiences(updateAudiences);
                    updateContext({
                      ...formFields,
                      audiences: updateAudiences,
                    });
                  }}
                  className="relative overflow-hidden"
                  suffixClassName="top-0 bottom-0 !right-0"
                  onEnter={() => addAudience()}
                >
                  {index > 0 && (
                    <DeleteButton onClick={() => removeAudience(index)} />
                  )}
                </BaseInput>
              ))}
            </div>
            <p
              className="p-xs font-medium text-disabled mt-2 mb-0 cursor-pointer"
              onClick={addAudience}
            >
              + Add another person this class is for
            </p>
          </div>
          <BaseInput
            label={
              <span>
                Max mentees allowed <span className="red">*</span>
              </span>
            }
            placeholder="Enter max amount of Mentees"
            selectClassName="h-14"
            name="capacity"
            type="number"
            value={formFields.mentees || formFields.capacity}
            onChange={(mentees) =>
              updateContext({
                ...formFields,
                mentees:
                  !isNaN(mentees.target.value) &&
                  Number(mentees.target.value) > 0
                    ? mentees.target.value
                    : 0,
              })
            }
            min={1}
            rules={[
              {
                required: true,
                message: "Please input a max amount of mentees!",
              },
              {
                validator: (_, value) => {
                  if (value && isNaN(value)) {
                    return Promise.reject("Please enter a valid number");
                  }
                  if (Number(value) < 1) {
                    return Promise.reject(
                      "Please enter a number greater than 0"
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          />

          {requirements.map((req, index) => (
            <BaseInput
              label={index === 0 ? "Class requirements" : ""}
              placeholder="E.g., A laptop"
              value={req}
              rules={[
                {
                  required: true,
                  message: "Please input a class requirement!",
                },
              ]}
              name={`requirements[${index}]`}
              key={index}
              onChange={(e) => {
                const updateRequirements = [...requirements];
                updateRequirements[index] = e.target.value;
                setRequirements(updateRequirements);
                updateContext({
                  ...formFields,
                  requirements: updateRequirements,
                });
              }}
              className="relative overflow-hidden"
              suffixClassName="top-0 bottom-0 !right-0"
              onEnter={() => addRequirements()}
            >
              {index > 0 && (
                <DeleteButton onClick={() => removeRequirement(index)} />
              )}
            </BaseInput>
          ))}
          <p
            className="p-xs font-medium text-disabled -mt-1 mb-0 cursor-pointer"
            onClick={addRequirements}
          >
            + Add another requirement
          </p>

          <>
            <div>
              <span className="p-xs font-medium text-main">
                <span>
                  Add Category<span className="red">*</span>
                </span>
              </span>
              <div className="relative" onClick={() => setAddTagsModal(true)}>
                <div className="main-input rounded-md w-full focus:outline-none px-5 py-[11px] h-14"></div>
                <p className="mb-0 text-placeholder p-sm absolute left-5 top-4">
                  Select category
                </p>
                <div className="flex gap-3 flex-wrap absolute left-5 top-[11px]">
                  {selectedCategory && (
                    <div
                      className="py-[7px] px-5 w-fit rounded-[32px] flex items-center gap-2.5 bg-pri shadow-4 text-white"
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteOrAddCategory(selectedCategory);
                      }}
                    >
                      <div className="flex items-center gap-1.5">
                        <img
                          src={getCategoryImage(selectedCategory?.category)}
                          className="w-4"
                          alt=""
                        />
                        <p className="p-2xs !font-medium mb-0">
                          {selectedCategory?.category}
                        </p>
                      </div>
                      <SvgClose className="text-white" />
                    </div>
                  )}
                </div>
                <button
                  className="top-6 absolute right-5 pointer-events-auto"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <img
                    src={`${getImageBaseUrl}/assets/caret-down.svg`}
                    className="w-[17px] h-2.5"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </>

          <Form.Item
            name="banner"
            rules={[{ required: true, message: "Please upload a banner!" }]}
          >
            <div>
              {
                <span className="p-xs font-medium text-main">
                  Upload cohort banner <span className="red">*</span>
                </span>
              }
              <div className="relative w-full h-[176px] main-input cursor-pointer">
                <input
                  type="file"
                  className="w-full h-full absolute top-0 left-0 right-0 bottom-0 opacity-0"
                  onChange={(e) => handleUpload(e.target.files[0])}
                />
                <div className="h-full flex justify-center items-center w-full">
                  {uploading ? (
                    <div className="w-full h-[50px] text-center">
                      <LoadingOutlined />
                    </div>
                  ) : (
                    <div
                      className="mx-auto w-full justify-center items-center flex flex-col py-6 min-h-[250px]"
                      style={{
                        backgroundImage: `url(${formFields.banner})`,
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                      }}
                    >
                      {!formFields.banner && (
                        <>
                          <div className="flex justify-center">
                            <img src={export_icon} alt="" className="" />
                          </div>

                          <p className="mb-0 p-xs text-light font-medium text-center mt-3 max-w-[200px] mx-auto">
                            Upload an image from your device or search online.
                          </p>
                        </>
                      )}

                      <div className="flex gap-3 mt-[5px] w-full justify-center">
                        <QalortButton className="border border-pri bg-pri-tint-3 pri py-[3px] px-[15px]">
                          Upload from device
                        </QalortButton>

                        <SearchOnline
                          selectImage={(banner) => {
                            updateContext({
                              ...formFields,
                              banner,
                            });
                            step1Form.setFieldsValue({ banner });
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Form.Item>
        </div>
        <div className="border-t border-grey-2 py-3.5 mt-9">
          <div className="flex gap-2.5 justify-end px-5 md:px-[62px]">
            <button
              className="border border-pri bg-pri-tint-3 pri py-2 px-9 rounded-md"
              type="button"
            >
              Cancel
            </button>
            <QalortButton
              type="primary"
              className="py-3 px-9"
              // onClick={handleProceed}
              htmlType="submit"
            >
              Proceed
            </QalortButton>
          </div>
        </div>
      </Wizard>

      <Modal
        visible={addTagsModal}
        footer={null}
        title={<h5 className="mb-0 font-semibold text-dark">Add category</h5>}
        closeIcon={
          <button
            className="bg-pri-tint-3 pri flex justify-center items-center w-10 h-10 border border-pri rounded-md [@media(max-width:984px)]:w-6[@media(max-width:984px)]:h-6 absolute right-6 top-4"
            data-testid="modal_close"
          >
            <SvgClose className="w-3.5 h-3.5" />
          </button>
        }
        onCancel={() => {
          setAddTagsModal(false);
        }}
        className="!w-[550px]"
      >
        <div className="flex flex-wrap gap-y-7 gap-x-4">
          {categories.map((item, index) => (
            <button
              data-testid={`option_${item.category}`}
              className={`py-[7px] px-5 w-fit rounded-[32px] flex items-center gap-2.5 shadow-4 ${
                checkIsActive(item)
                  ? "text-white bg-pri"
                  : "border-light bg-pri-tint-3 text-main"
              }`}
              key={index}
              onClick={() => deleteOrAddCategory(item)}
            >
              <div className="flex items-center gap-1.5">
                <img
                  src={getCategoryImage(item.category)}
                  className="w-4"
                  alt=""
                />
                <p className="mb-0 p-xs font-medium">{item.category}</p>
              </div>

              <SvgClose
                className={`${
                  checkIsActive(item) ? "text-white" : "text-light"
                }`}
              />
            </button>
          ))}
        </div>
      </Modal>
    </Form>
  );
}

export default CohortDetails;
